import React, { useState } from "react";
import { Link } from "@reach/router";
import styles from "./Casefile.module.scss";

function MicrobeNpc(props) {
  const [microbeNo, setMicrobeNo] = React.useState(0);

  if (microbeNo === 0) {
    return (
      <div className={styles.queryBox}>
        <p>
          Hi I'm Photorhabdus luminescens, I'm tiny and I glow. I live inside
          worms, at Dingle Vale allotments, it's a really nice little set up
          here, we get the humans to farm little cabbages. We're not interested
          in cabbages, they taste terrible and they are no fun to eat, but we
          feed on the caterpillars and they love the cabbages, so we're never
          short of food, well that's how it used to work anyway. Have you seen
          any Caterpillars around? I'm starving.
        </p>
        <button
          onClick={(event) => {
            setMicrobeNo(1);
          }}
        >
          Yes
        </button>
        <button
          onClick={(event) => {
            setMicrobeNo(4);
          }}
        >
          No
        </button>
      </div>
    );
  }

  if (microbeNo === 1) {
    return (
      <div className={styles.queryBox}>
        <p>
          Ah great! That's really good because I feed off them. Well Actually,
          What I do is take a ride in these worms, and get the worms to suck the
          caterpilla's blood, then I nip in and make a home in the caterpillar.
          I get comfy, start to reproduce and then burst out of their body -
          it's brilliant! Do you want to hear more about
        </p>
        <button
          onClick={(event) => {
            setMicrobeNo(2);
          }}
        >
          how I get the worms to get me into the caterpillar?
        </button>
        or
        <button
          onClick={(event) => {
            setMicrobeNo(6);
          }}
        >
          How it feels to burst out of a big caterpilla
        </button>
      </div>
    );
  }
  if (microbeNo === 2) {
    return (
      <div className={styles.queryBox}>
        <p>
          Ah great! That's really good because I feed off them. Well Actually,
          What I do is take a ride in these worms, and get the worms to suck the
          caterpillar's blood, then I nip in and make a home in the caterpillar.
          I get comfy, start to reproduce and then burst out of their body -
          it's brilliant! Do you want to hear more about
        </p>
        <button
          onClick={(event) => {
            setMicrobeNo(3);
          }}
        >
          how I get the worms to get me into the caterpillar?
        </button>
        or
        <button
          onClick={(event) => {
            setMicrobeNo(1);
          }}
        >
          How it feels to burst out of a big caterpilla
        </button>
      </div>
    );
  }
  if (microbeNo === 3) {
    return (
      <div className={styles.queryBox}>
        <p>
          I act as accomplice to a tiny worm called a nematode. The nematode
          carries me around in its gut until it finds a suitable victim, like a
          big fat caterpillar. The nematode worms it's way into the insect's
          bloodstream, then spits me up, then once I get settled I reproduce and
          spew out toxins that kill the insect, enzymes that liquefy it, and
          antibiotics that prevent any other microbes from getting in on the
          feast. We both reproduce inside the carcass until finally new
          nematodes bursts forth with me still riding inside them! Human's don't
          know why I glow, but I can tell you. First of all because it just
          looks amazing a feels really good, then there is the side benefit that
          the glow attracts other caterpillars and other dumb insects so we can
          eat them too. Tell you what though, lately the caterpillar numbers are
          really thinning out, do you want to know why?
        </p>
        <button
          onClick={(event) => {
            setMicrobeNo(4);
          }}
        >
          Yes
        </button>

        <button
          onClick={(event) => {
            setMicrobeNo(7);
          }}
        >
          No
        </button>
      </div>
    );
  }
  if (microbeNo === 4) {
    return (
      <div className={styles.queryBox}>
        <p>
          More and more of the humans in the gardens around here are using their
          crazy chemicals to try and stop the weeds, which is funny because it
          never works! This 'Round Up' chemical kills off loads of plants and
          insects, even the caterpillars. Do you think I should try and talk to
          my folk champion and get some help?
        </p>
        <button
          onClick={(event) => {
            setMicrobeNo(1);
          }}
        >
          yes talk to your champion the Ecoli
        </button>

        <button
          onClick={(event) => {
            setMicrobeNo(5);
          }}
        >
          no, just stop moaning
        </button>
      </div>
    );
  }
  if (microbeNo === 5) {
    return (
      <div className={styles.queryBox}>
        <p>
          Whoa, that's a bit harsh! Ok, well if you're going to be like that
          then what's the point in me even trying to talk to you? Later loser!
        </p>
      </div>
    );
  }
  if (microbeNo === 6) {
    return (
      <div className={styles.queryBox}>
        <p>
          It feels amazing, there is nothing better than bursting out of a big
          dumb caterpillar and splurging all over the place! But lately I've
          been finding it harder to find caterpillars, do you want to know more
          about that?
          <button
            onClick={(event) => {
              setMicrobeNo(4);
            }}
          >
            Yes
          </button>
          <button
            onClick={(event) => {
              setMicrobeNo(7);
            }}
          >
            No
          </button>
        </p>
      </div>
    );
  }
  if (microbeNo === 7) {
    return (
      <div className={styles.queryBox}>
        <p>Ok fair enough, we've all got things to do, see you around!</p>
      </div>
    );
  }
}

export default MicrobeNpc;
